<template>
  <div v-if="!requestBooking">
    <BaseButton
      v-if="bookingResponse && bookingResponse.ical_url && !showShareButtons"
      :style="{ color: widgetSettings.color }"
      fullWidth
      @click="showShareButtons = true"
      v-test="'add-to-calendar-toggle'"
    >
      {{ $t('completed.calendar_link_label') }}
    </BaseButton>
    <div v-else :class="$style.heading">
      {{ $t('completed.calendar_link_label') }}
    </div>
    <div v-if="showShareButtons" :class="$style.buttons">
      <a
        v-for="(button, index) in shareButtons"
        :key="index"
        :href="button.href"
        target="_blank"
        :class="$style.button"
        v-test="`add-to-calendar-${button.name}`"
      >
        <svg
          v-if="button.name === 'google'"
          xmlns="http://www.w3.org/2000/svg"
          width="33"
          height="32"
          fill="none"
          viewBox="0 0 33 32"
        >
          <path
            fill="gray"
            d="M.114 16c0-8.822 7.178-16 16-16 3.563 0 6.936 1.146 9.753 3.315l-3.718 4.83a9.809 9.809 0 0 0-6.035-2.05C10.653 6.095 6.21 10.54 6.21 16c0 5.462 4.444 9.905 9.905 9.905 4.399 0 8.137-2.882 9.425-6.857h-9.425v-6.096h16V16c0 8.822-7.177 16-16 16-8.822 0-16-7.178-16-16Z"
          />
        </svg>
        <svg
          v-if="button.name === 'apple'"
          xmlns="http://www.w3.org/2000/svg"
          width="28"
          height="32"
          fill="none"
          viewBox="0 0 28 32"
        >
          <path
            fill="gray"
            fill-rule="evenodd"
            d="M18.628 5.109C19.794 3.757 20.58 1.874 20.366 0c-1.681.064-3.715 1.074-4.92 2.424-1.083 1.199-2.028 3.113-1.774 4.95 1.875.14 3.79-.912 4.956-2.265ZM22.833 17c.047 4.843 4.433 6.454 4.482 6.475-.036.114-.701 2.296-2.31 4.552-1.394 1.949-2.839 3.89-5.115 3.931-2.236.04-2.956-1.27-5.514-1.27-2.556 0-3.356 1.228-5.472 1.31-2.197.078-3.872-2.108-5.274-4.05C.76 23.973-1.433 16.72 1.512 11.823c1.462-2.43 4.075-3.971 6.913-4.01 2.157-.04 4.194 1.39 5.512 1.39 1.32 0 3.795-1.72 6.396-1.466 1.089.043 4.147.42 6.11 3.174-.16.094-3.649 2.04-3.61 6.088Z"
            clip-rule="evenodd"
          />
        </svg>
        <svg
          v-if="button.name === 'outlook'"
          xmlns="http://www.w3.org/2000/svg"
          width="37"
          height="32"
          fill="none"
          viewBox="0 0 37 32"
        >
          <path
            fill="gray"
            d="M12.322 16.061c0 .457-.056.899-.167 1.326-.102.416-.27.792-.503 1.127-.224.335-.518.6-.884.793-.376.203-.818.304-1.326.304-.508 0-.94-.101-1.295-.304a2.636 2.636 0 0 1-.869-.838 3.76 3.76 0 0 1-.503-1.143 5.639 5.639 0 0 1-.152-1.31c0-.448.05-.89.152-1.326.102-.437.275-.823.518-1.159a2.42 2.42 0 0 1 .9-.822c.365-.204.807-.305 1.325-.305.518 0 .955.101 1.31.305.356.213.646.492.87.838.223.345.38.736.472 1.173a5.9 5.9 0 0 1 .152 1.341ZM36.886 16v14.293A1.693 1.693 0 0 1 35.164 32H11.179a1.693 1.693 0 0 1-1.706-1.722v-5.135H1.838a1.43 1.43 0 0 1-1.066-.457 1.43 1.43 0 0 1-.458-1.067V8.381c0-.417.153-.772.458-1.067.284-.304.64-.457 1.066-.457h9.905V1.6c0-.447.152-.828.457-1.143.305-.305.686-.457 1.143-.457H33c.447 0 .828.152 1.143.457.305.305.457.686.457 1.143v12.648l1.89 1.097h.015c.101.07.193.162.274.274a.746.746 0 0 1 .107.381ZM27.743 3.429V8h4.572V3.429h-4.572Zm0 6.857v4.571h4.572v-4.571h-4.572Zm0 6.857v2.788l4.648-2.788h-4.648Zm-8-13.714V8h5.714V3.429h-5.714Zm0 6.857v4.571h5.714v-4.571h-5.714Zm0 6.857v3.093l3.672 2.286 2.042-1.22v-4.16h-5.714ZM14.029 3.429v3.428h3.047l.198.015.183.061V3.43H14.03ZM9.427 22.065c.914 0 1.727-.153 2.438-.457a5.508 5.508 0 0 0 1.813-1.31 5.777 5.777 0 0 0 1.113-1.951 7.62 7.62 0 0 0 .38-2.454c0-.843-.126-1.63-.38-2.362a5.435 5.435 0 0 0-1.082-1.89 5.011 5.011 0 0 0-1.753-1.264c-.69-.305-1.478-.457-2.362-.457-.934 0-1.767.152-2.499.457a5.039 5.039 0 0 0-1.828 1.295 5.317 5.317 0 0 0-1.143 1.981c-.254.752-.381 1.58-.381 2.484 0 .864.132 1.656.396 2.377.264.732.64 1.357 1.128 1.875.487.528 1.082.94 1.783 1.234.7.305 1.493.457 2.377.457v-.015Zm2.316 7.65h18.88L18.6 22.216v1.402c0 .417-.152.772-.457 1.067a1.43 1.43 0 0 1-1.067.457h-5.333v4.571Zm22.857-.199V18.484l-8.99 5.394 8.99 5.638Z"
          />
        </svg>
      </a>
    </div>
  </div>
</template>

<script setup lang="ts">
import dayjs from 'dayjs';
import { computed, ref } from 'vue';

import BaseButton from '@/components/BaseButton.vue';
import { useBookingStore } from '@/stores/booking';
import { useCompanyStore } from '@/stores/company';
import widgetSettings from '@/widget-settings';

const { bookingResponse } = useBookingStore();
const { requestBooking } = useCompanyStore();
const showShareButtons = ref(false);

const calendarLinks = computed(() => {
  const { totalDuration, date, time, services, locationId } = useBookingStore();

  const hours = Number.parseInt(time.split(':')[0]);
  const minutes = Number.parseInt(time.split(':')[1]);

  const dateTimeStart = dayjs(date).set('hour', hours).set('minute', minutes);
  const dateTimeEnd = dateTimeStart.add(totalDuration, 'minute');

  const dateFormatted = dateTimeStart.format('YYYYMMDD');
  const startFormatted = `${dateFormatted}T${dateTimeStart.format('HHmm')}00`;
  const endFormatted = `${dateFormatted}T${dateTimeEnd.format('HHmm')}00`;

  const serviceNames = services.map((service) => service.name).join(', ');

  const { company } = useCompanyStore();
  const locations = company.locations;

  let address = '';
  if (locations?.length) {
    const location = locationId
      ? locations.find((location) => location.id === locationId)
      : locations[0];
    address =
      location.address && location.city
        ? `${location.address}, ${location.city}`
        : '';
  }

  return {
    google: encodeURI(
      `https://calendar.google.com/calendar/render?action=TEMPLATE&text=${serviceNames}&dates=${startFormatted}/${endFormatted}${address ? `&location=${address}` : ''}`
    ),
    outlook: `https://outlook.live.com/calendar/0/deeplink/compose?allday=false&subject=${encodeURIComponent(serviceNames)}&startdt=${encodeURIComponent(dateTimeStart.format())}&enddt=${encodeURIComponent(dateTimeEnd.format())}${address ? `&location=${encodeURIComponent(address)}` : ''}&path=%2Fcalendar%2Faction%2Fcompose&rru=addevent`
  };
});

const shareButtons = computed(() =>
  bookingResponse
    ? [
        {
          name: 'google',
          href: calendarLinks.value.google
        },
        {
          name: 'apple',
          href: bookingResponse.ical_url
        },
        {
          name: 'outlook',
          href: calendarLinks.value.outlook
        }
      ]
    : []
);
</script>

<style lang="scss" module>
.heading {
  font-size: 16px;
  text-align: center;
  margin: $spacing * 0.5 0;
}

.buttons {
  display: flex;
  justify-content: center;
  margin-bottom: $spacing * 1.5;
}

.button {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 64px;
  height: 64px;
  margin: 6px;
  border-radius: $border-radius;
  border: 1px solid rgba(0, 0, 0, 0.13);
  cursor: pointer;
  color: inherit;
  text-decoration: none;
}
</style>
